import moment from 'moment'

export const dateCol = dates => (_.isNull(dates) || !dates.length)
    ? 'No Dates Set'
    : dates.join('<br />');

export const parseMoment = (date, format = 'YYYY-MM-DD HH:mm:ss', addUTC = true) => {
    if (addUTC) {
        date += ' +0000'
        format += ' Z'
    }
    return moment(date, format)
}
